
/**
   * @component HelpIcon
   *
   * @public
   */

export default {
  name: 'HelpIcon',
};
